import { ThemeName } from '@im/im-theme';
import { createContext } from 'react';

export type SiteConfigStorefrontInfo = {
  colorScheme: ThemeName;
  displayName: string;
  favicon: string;
  logo: string;
};

export type SiteConfig = {
  /** OKTA issuer */
  authServer: string;

  /** OKTA clientId */
  clientId: string;

  /** Default locale like: "en-CA".
   * Defaults to first locale in `Accept-Language` header that exists in `supportedLocales`.
   * If not found; (`Accept-Language` header missing or no locale in header exist in `supportedLocales`)
   * then returns the first locale in `supportedLocales`.
   */
  defaultLocale: string;

  /** Server environment like: "stage1" */
  environment: string;

  /** fullstory enabled like: true or false */
  fullStoryEnabled: boolean;

  /** redirect to IDP web site to login */
  idpLogin: boolean;

  /** authorization code flow vs interaction code flow */
  interactionCodeFlow: boolean;

  /** Site code like: "ca" */
  siteCode: string;

  /** For X4EC only, displays details needed on initial render and prior to login */
  storefrontInfo?: SiteConfigStorefrontInfo;

  /** Supported locales like: ["en-CA","fr-CA"] */
  supportedLocales: string[];
};

export const siteConfigContext = createContext<SiteConfig | undefined>(
  undefined
);
